import { RECOMMENDED_VOICES_QUERY } from "@/constants/voiceSelection";
import type { FeatureAnnouncement } from "@/types/featureAnnouncement";

/** Earlier entries win when several are eligible on the same surface. */
export const FEATURE_ANNOUNCEMENTS: readonly FeatureAnnouncement[] = [
  {
    id: "script-editor-new-voices",
    version: "v2",
    surface: "phoneScriptEditor",
    flagKey: "ui-new-voices-announcement",
    namespace: "common",
    titleKey: "featureAnnouncement.newVoices.title",
    descriptionKey: "featureAnnouncement.newVoices.description",
    primaryLabelKey: "featureAnnouncement.newVoices.primary",
    primaryHref: RECOMMENDED_VOICES_QUERY,
    primarySideEffect: "realtimeModelUpgrade",
    perOrg: true,
    media: { type: "image", src: "/images/announcements/new-voices.png" },
  },
];

export const FEATURE_ANNOUNCEMENT_DELAY_MS = 1500;
